$(document).ready(function () {

  function featureCollectionSlider() {
    $(".wc-index .new-featured-collection-slider.full-slider").slick({
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      // prevArrow: '<button class="slide-arrow prev-arrow vertical-text">Previous</button>',
      // nextArrow: '<button class="slide-arrow next-arrow vertical-text">Next</button>',
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            arrows: true,
            dots: false,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  function featureCollectionHalfSlider() {
    $(".wc-index .new-featured-collection-slider.half-slider").slick({
      infinite: false,
      speed: 500,
      slidesToShow: 3.5,
      slidesToScroll: 1,
      // prevArrow: '<button class="slide-arrow prev-arrow vertical-text">Previous</button>',
      // nextArrow: '<button class="slide-arrow next-arrow vertical-text">Next</button>',
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3.5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.5,
            arrows: true,
            dots: false,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  function ListCollectionSlider() {
    $(".full-grid .list-collection-slider").slick({
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      // prevArrow: '<button class="slide-arrow prev-arrow vertical-text">Previous</button>',
      // nextArrow: '<button class="slide-arrow next-arrow vertical-text">Next</button>',
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.5,
            arrows: true,
            dots: false,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  function ListCollectionHalfSlider() {
    $(".half-grid .list-collection-slider").slick({
      infinite: false,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      // prevArrow: '<button class="slide-arrow prev-arrow vertical-text">Previous</button>',
      // nextArrow: '<button class="slide-arrow next-arrow vertical-text">Next</button>',
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.5,
            arrows: true,
            dots: false,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  function testimonialSlider() {
    $(".testimonial-carousel").slick({
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dotsClass: 'new-slider-slide-dots',
      dots: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            arrows: true,
            dots: true,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  // function complementaryProductSlider() {
  //   $(".pdp-related-product-section").slick({
  //     dots: true,
  //     arrows: true,
  //     infinite: false,
  //     speed: 300,
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     rows: 0,
  //   });
  // }
  
  // initialize Slick on Full screen
  testimonialSlider();
  
  // initialize Slick on desktop screen
  if (window.innerWidth > 769) {
    featureCollectionSlider();
    featureCollectionHalfSlider();
    ListCollectionSlider();
    ListCollectionHalfSlider();

    // categorySlider();
    // setTimeout(function() {
    //    relatedProductSlider();
    // }, 2500)
  }

  // function categorySlider() {
  //   $('.brands-list').slick({
  //       infinite: false,
  //       speed: 500,
  //       slidesToShow: 3.5,
  //       slidesToScroll: 1,
  //       arrows: true,
  //       dots: false
  //   });
  // }

  // function relatedProductSlider() {
  //   $(".related-products-slider").slick({
  //     infinite: false,
  //     speed: 500,
  //     slidesToShow: 2.5,
  //     slidesToScroll: 1,
  //     arrows: false,
  //     dots: false,
  //   });
  // }

  //Initialize slick js When open menu-drawer
  $("#Details-menu-drawer-container").on("click", function () {
    if ($(".megaMenuItem").length > 0) {
      $(".megaMenuItem").slick({
        infinite: false,
        speed: 500,
        slidesToShow: 1.5,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
      });
    }
  });
});

//Sticky transparent header
var header = $(".sticky_transparent_header");
var headerOffset = header.offset().top;

$(window).scroll(function () {
  if ($(window).scrollTop() > 50) {
    header.removeClass("transparent_header");
  } else {
    header.addClass("transparent_header");
  }
});

//PDP Description Tab Section
$(document).ready(function () {
  $(".tab").click(function () {
    var tabId = $(this).data("tab");

    $(".tab, .tab-content").removeClass("active");
    $(this).addClass("active");
    $("#" + tabId).addClass("active");
  });
});

//PDP marquee infinite loop
$(document).ready(function () {
  var marquee_width = $(".marquee-content-primary").width();
  document.documentElement.style.setProperty(
    "--marquee-padding",
    marquee_width + "px"
  );
});

//Popup Script
$(document).ready(function () {
  // When the button is clicked, open the popup and show the overlay
  $("#showPopup").click(function () {
    $("#showPopupBody").show();
    $(".popup-overlay").show();
  });

  // When the close button is clicked, close the popup and hide the overlay
  $("#hidePopup").click(function () {
    $("#showPopupBody").hide();
    $(".popup-overlay").hide();
  });

  $(".new-slideshow").slick({
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 7000,
    autoplay: true,
    // prevArrow: '<button class="slide-arrow prev-arrow vertical-text">Previous</button>',
    // nextArrow: '<button class="slide-arrow next-arrow vertical-text">Next</button>',
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: true,
          dots: false,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

document.querySelector("html").scrollIntoView({
  behavior: "smooth",
});






window.onload = function() {
    setTimeout(function() {
        document.querySelector('.qr_wa_icon').style.display = 'block'
    }, 7000)
}